import { useEffect, useRef, useState } from "react"

import "../Login/style.css"
import "./whatsappForm.css"

// import logo from "../../assets/logo.png"
import ReCAPTCHA from "react-google-recaptcha-enterprise";
import { Helmet } from "react-helmet";
import chatApi from "../../services/api/chat";
import acessoAtendimentoAPi, { updateAcessoAtendimento_requestDTO } from "@/services/api/acessoAtendimento";
import { Tela2 } from "./components/tela2/tela2";

const captchaKey: string | undefined = import.meta.env.VITE_CAPTCHA_KEY ?? undefined;
const isCaptchaEnabled: "true" | "false" | undefined = import.meta.env.VITE_CAPTCHA_ENABLED ?? 'false'
const isFacebookPixelEnabled: 'true' | 'false' | undefined = import.meta.env.VITE_FACEBOOK_PIXEL_ENABLED ?? 'false'
const isGoogleGtagEnabled: 'true' | 'false' | undefined = import.meta.env.VITE_GOOGLE_GTAG_ENABLED ?? 'false'

export type AtendimentoFormValues = {
    nome: string,
    telefone: string,
    regiao?: string,
    setRegiao: (value: string) => void,
    setTelefone: (value: string) => void,
    setNome: (value: string) => void,
    submit: () => void
}

export function WhatsappForm() {

    const [codigoAtendimento, setCodigoAtendimento] = useState<string>("FORMULARIO_SEM_FONTE");

    const [urlParams, setUrlParams] = useState<any>({});
    const [captchaToken, setCaptchaToken] = useState<string | undefined>();
    const [acessoAtendimento, setAcessoAtendimento] = useState<updateAcessoAtendimento_requestDTO | undefined>();

    const [tela, setTela] = useState<string | undefined>();

    const captchaRef = useRef<ReCAPTCHA>(null);

    useEffect(() => {

        const url = new URL(window.location.href);
        const searchParams = new URLSearchParams(url.search);

        const paramsObj: any = {}

        for (const [key, value] of searchParams.entries()) {
            paramsObj[key] = value;
        }
        setUrlParams(paramsObj);

        const dia = 24 * 60 * 60 * 1000;

        // Verifica se o parâmetro "tela" está na URL
        const telaParam = searchParams.get('tela');

        //sorteando tela que vai ser exibida para o usuário
        //Transformar em string "tela1" "tela2"
        //salvar no back como formId
        const telaLocalStorage = localStorage.getItem('tela')
        let telaInfo = undefined
        const idTela = ['tela1', 'tela2'][Math.floor(Math.random() * 2)]

        try {
            telaInfo = telaLocalStorage ? JSON.parse(telaLocalStorage) : undefined
            console.log("telaInfo apos parse: ", telaInfo)
        } catch (err) {
            console.log("removendo tela do localstorage pois:", err)
            localStorage.removeItem('tela')
        }

        // Se o parâmetro "tela" está na URL, usa ele
        if (telaParam === '1' || telaParam === '2') {
            const telaEscolhida = `tela${telaParam}`;
            telaInfo = { tela: telaEscolhida, expirationDate: new Date().getTime() + dia };
            localStorage.setItem('tela', JSON.stringify(telaInfo));
            setTela(telaEscolhida);
            console.log("Usando tela definida pelo parâmetro da URL:", telaEscolhida);
        } else {

            // Caso contrário, usa a lógica existente para definir a tela
            if (telaInfo && new Date() > new Date(telaInfo.expirationDate)) {
                console.log("telaInfo.expirationDate < new Date()")
                telaInfo.tela = idTela;
                telaInfo.expirationDate = new Date().getTime() + dia; // Atualizar a data de expiração
                localStorage.setItem('tela', JSON.stringify(telaInfo))
                console.log("dentro do if, setando tela como: ", telaInfo.tela)
                setTela(idTela)
            }

            else if (!telaInfo) {
                console.log("telaInfo == undefined");
                telaInfo = { tela: idTela, expirationDate: new Date().getTime() + dia }
                localStorage.setItem('tela', JSON.stringify(telaInfo))
                console.log("dentro do if, setando tela como: ", telaInfo.tela)
                setTela(idTela)
            }

            else if (telaInfo && new Date(telaInfo.expirationDate) > new Date()) {
                console.log("telaInfo.expirationDate > new Date()")
                console.log("dentro do if, setando tela como: ", telaInfo.tela)
                setTela(telaInfo.tela)
            }
        }

        if (telaInfo) {
            // Requisição informando que usuário acessou a pagina
            acessoAtendimentoAPi.accessedAtendimento(window.location.href, telaInfo.tela).then((response) => {
                setAcessoAtendimento(response.data)
            })
        }

        console.log("isFacebookPixelEnabled", isFacebookPixelEnabled)
        console.log("isGoogleGtagEnabled", isGoogleGtagEnabled)


    }, [])

    const loadScripts = () => {
        console.log("Carregando scripts de rastreamento...");
        if (isFacebookPixelEnabled == 'true') {
            console.log("Facebook Pixel está habilitado");
        // Facebook Pixel script
        const fbScript = document.createElement('script');
        fbScript.innerHTML = `
            !function(f,b,e,v,n,t,s)
            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window,  document,'script',
            'https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', '1508318363043058');
            fbq('track', 'PageView');
            console.log("Facebook Pixel enabled");
        `;

        console.log("Elemento fbScript criado: ", fbScript);

        document.head.appendChild(fbScript);

        console.log("Elemento fbScript adicionado ao head");

        // Facebook noscript fallback
        const noscript = document.createElement('noscript');
        noscript.innerHTML = `
            <img height="1" width="1" style="display:none"
                src="https://www.facebook.com/tr?id=1508318363043058&ev=PageView&noscript=1"/>
        `;

        console.log("Elemento noscript criado: ", noscript);

        document.body.appendChild(noscript);

        console.log("Elemento noscript adicionado ao body");
        }

        if (isGoogleGtagEnabled == 'true') {
        // Google Gtag script tag
        const gtagScript = document.createElement('script');
        gtagScript.async = true;
        gtagScript.src = 'https://www.googletagmanager.com/gtag/js?id=AW-11427696594';
        document.head.appendChild(gtagScript);

        // Gtag config script
        const configScript = document.createElement('script');
        configScript.innerHTML = `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', 'AW-11427696594');
            console.log("Google Gtag enabled");
        `;
        document.head.appendChild(configScript);
        }
    }

    useEffect(() => {
        console.log("setando tela como: ", tela)
    }, [tela])


    const [nome, setNome] = useState<string>("");
    const [phone, setPhone] = useState<string>("+55");
    const [message, setMessage] = useState<string | undefined>()
    const [regiao, setRegiao] = useState<string | undefined>()
    const [ok, setOk] = useState<string | undefined>()

    const [handled, setHandled] = useState<boolean>(false);

    const handleSendMessage = async () => {

        let token = undefined

        if (captchaRef.current) {
            token = await captchaRef.current.executeAsync();
            captchaRef.current.reset();
        }

        if (phone.length < 9) {
            setMessage("Informe o telefone corretamente. O número precisa conter o número do país (55 para o Brasil), DDD e o número de telefone.")
            return;
        }

        if (nome.trim() == "") {
            setMessage("O campo nome é obrigatório.")
            return;
        }


        setHandled(true)
        setMessage("Estamos te encaminhando para o Whatsapp...")


        try {

            const response = await chatApi.newChat({
                phone: phone,
                name: nome,
                origin: codigoAtendimento,
                regiao: regiao,
                captchaToken: token ?? undefined,
                ...urlParams
            })

            if (response.status == 500) {
                throw new Error(response.data)
            }

            setOk(response.status == 200 ? "ok" : "")


            if (acessoAtendimento) {
                await acessoAtendimentoAPi.updateAtendimento(acessoAtendimento.id, {
                    ...acessoAtendimento,
                    formularioRespondido: true,
                    nome: nome,
                    telefone: phone
                })
            }

            if(response.status == 200)
                window.location.href = "https://wa.me/5583920004180";

            else {
                throw new Error("response: " + response)
            }

        }
        catch (err: any) {
            setOk("")
            console.log(err)
            setMessage("Houve um erro ao iniciar o chat. O número precisa conter o número do país (55 para o Brasil), DDD e o número de telefone.")
            setHandled(false)
        }
    }



    return (


        <div className="">
            <Tela2
                nome={nome}
                setNome={setNome}
                telefone={phone}
                setTelefone={setPhone}
                submit={handleSendMessage}
                regiao={regiao}
                setRegiao={setRegiao}
            /> 
            {
                captchaKey && isCaptchaEnabled == 'true' ?
                    <ReCAPTCHA
                        size="invisible"
                        sitekey={captchaKey}
                        onChange={(token) => { setCaptchaToken(token ?? undefined) }}
                        ref={captchaRef}
                    />
                    : <></>
            }



        </div>
    )

}
